import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { ADD_AIR_SHIPMENT_INFO, ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO, ADD_SEA_SHIPMENT_INFO, AIR_SHIPPER_INFO_STATUS_UPDATE, DELETE_QUOTES, GET_AIR_SHIPPER_INFO_BY_ID, GET_ALL_QUOTES, GET_BY_ID_QUOTES, GET_SEA_SHIPPER_INFO_BY_ID, QUOTE_STATUS_UPDATE, SEA_SHIPPER_INFO_STATUS_UPDATE } from "./actionType"
import { addQuotesSeaExportGeneralCargoSuccess, addQuotesSeaExportGeneralCargoError, getAllQuotesSuccess, getAllQuotesFail, getByIdQuotesFail, getByIdQuotesSuccess, deleteQuoteSuccess, deleteQuoteFail, quoteStatusUpdateFail, quoteStatusUpdateSuccess, addAirShiiperInfoLoader, addAirShiiperInfoError, getAirShipperInfoFail, getAirShipperInfoLoader, getAirShipperInfoSuccess, addAirShiiperInfoSuccess, addSeaShipperInfoLoader, addSeaShipperInfoSuccess, addSeaShipperInfoError, getSeaShipperInfoLoader, getSeaShipperInfoSuccess, getSeaShipperInfoFail, airShipperInfoStatusUpdateLoader, airShipperInfoStatusUpdateFail, airShipperInfoStatusUpdateSuccess, seaShipperInfoStatusUpdateFail, seaShipperInfoStatusUpdateSuccess, seaShipperInfoStatusUpdateLoader } from "./action"
//Include Both Helper File with needed methods
import { postAddQuotesSeaExportGeneralCargo, getAllQuotes, getByIdQuote, deleteQuote, quoteStatusUpdate, addNewShipper, addSeaShipper, getAirShipperInfoByShipperId, getSeaShipperInfoByShipperId, airShipperInfoStatusUpdate, seaShipperInfoStatusUpdate } from "../../helpers/backend_helper"
import "toastr/build/toastr.min.css"
import toast from "react-hot-toast";

//add quotes
function* addQuotesSeaExportGeneralCargo({ payload: { data, history } }) {

  try {
    const response = yield call(postAddQuotesSeaExportGeneralCargo, data)
    if (response?.status?.toLowerCase() === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(addQuotesSeaExportGeneralCargoSuccess(response))
      history.push('/enquiries')
    }
  } catch (error) {
    yield put(addQuotesSeaExportGeneralCargoError(error))
    toast.error(error.response.data.message)
  }
}

function* AddQuotesSeaExportGeneralCargoSaga() {
  yield takeEvery(ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO, addQuotesSeaExportGeneralCargo)
}

export default AddQuotesSeaExportGeneralCargoSaga

//Get All quotes
function* fetchQuotes() {
  try {
    const response = yield call(getAllQuotes)
    yield put(getAllQuotesSuccess(response))
  } catch (error) {
    yield put(getAllQuotesFail(error))
  }
}
export function* QuotesListSaga() {
  yield takeEvery(GET_ALL_QUOTES, fetchQuotes)
}

//Get by id quote
function* fetchQuoteBYId({ payload: { id, history } }) {
  try {
    const response = yield call(getByIdQuote, id)
    if (response?.status?.toLowerCase() === 'error') {
      toast.error(response.message);
      history.push('/enquiries');
    } else {
      yield put(getByIdQuotesSuccess(response))
    }
  } catch (error) {
    yield put(getByIdQuotesFail(error))
  }
}
export function* QuoteByIdSaga() {
  yield takeEvery(GET_BY_ID_QUOTES, fetchQuoteBYId)
}

//delete quotes
function* DeleteQuote({ payload: data }) {
  try {
    const response = yield call(deleteQuote, data)
    if (response?.status?.toLowerCase() === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(deleteQuoteSuccess(response))
      history.push("/enquiries");
    }
  } catch (error) {
    yield put(deleteQuoteFail(error))
  }
}

export function* DeleteQuoteSaga() {
  yield takeEvery(DELETE_QUOTES, DeleteQuote)
}

//quotes status update
function* QuoteStatusUpdate({ payload: { data, resetForm, dispatch, getByIdQuotes, id, history } }) {
  try {
    const response = yield call(quoteStatusUpdate, data)
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(quoteStatusUpdateSuccess(response))
      resetForm
      dispatch(getByIdQuotes(id, history))
    }
  } catch (error) {
    yield put(quoteStatusUpdateFail(error))
  }
}

export function* QuoteStatusUpdateSaga() {
  yield takeEvery(QUOTE_STATUS_UPDATE, QuoteStatusUpdate)
}

// add new shiiper information
function* newShipper({ payload: { data, history } }) {
  try {
    yield put(addAirShiiperInfoLoader(true))
    const response = yield call(addNewShipper, data)
    yield put(addAirShiiperInfoLoader(false))
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(addAirShiiperInfoSuccess(response))
      history.push("/enquiries");
    }
  } catch (error) {
    yield put(addAirShiiperInfoError(error))
  }
}

export function* AddAirShipperInfoSaga() {
  yield takeEvery(ADD_AIR_SHIPMENT_INFO, newShipper)
}

//Get air shipper information by shipper id
function* getAirShipperInfoById({ payload: { id, history } }) {
  try {
    yield put(getAirShipperInfoLoader(true))
    const response = yield call(getAirShipperInfoByShipperId, id)
    yield put(getAirShipperInfoLoader(false))
    if (response?.status?.toLowerCase() === 'error') {
      toast.error(response.message);
      history.push('/enquiries');
    } else {
      yield put(getAirShipperInfoSuccess(response))
    }
  } catch (error) {
    yield put(getAirShipperInfoFail(error))
  }
}
export function* GetAirShipperInfoByIdSaga() {
  yield takeEvery(GET_AIR_SHIPPER_INFO_BY_ID, getAirShipperInfoById)
}

// add sea shipper information
function* newSeaShipper({ payload: { data, history } }) {
  try {
    yield put(addSeaShipperInfoLoader(true))
    const response = yield call(addSeaShipper, data)
    yield put(addSeaShipperInfoLoader(false))
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(addSeaShipperInfoSuccess(response))
      history.push("/enquiries");
    }
  } catch (error) {
    yield put(addSeaShipperInfoError(error))
  }
}

export function* AddSeaShipperInfoSaga() {
  yield takeEvery(ADD_SEA_SHIPMENT_INFO, newSeaShipper)
}

//Get sea shipper information by shipper id
function* getSeaShipperInfoById({ payload: { id, history } }) {
  try {
    yield put(getSeaShipperInfoLoader(true))
    const response = yield call(getSeaShipperInfoByShipperId, id)
    yield put(getSeaShipperInfoLoader(false))
    if (response?.status?.toLowerCase() === 'error') {
      toast.error(response.message);
      history.push('/enquiries');
    } else {
      yield put(getSeaShipperInfoSuccess(response))
    }
  } catch (error) {
    yield put(getSeaShipperInfoFail(error))
  }
}
export function* GetSeaShipperInfoByIdSaga() {
  yield takeEvery(GET_SEA_SHIPPER_INFO_BY_ID, getSeaShipperInfoById)
}

//Air shipper information status update
function* AirShipperInfoStatusUpdate({ payload: { data, resetForm, dispatch, getAirShipperInfo, shipperId, history } }) {
  try {
    yield put(airShipperInfoStatusUpdateLoader(true))
    const response = yield call(airShipperInfoStatusUpdate, data)
    yield put(airShipperInfoStatusUpdateLoader(false))
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(airShipperInfoStatusUpdateSuccess(response))
      resetForm
      dispatch(getAirShipperInfo(shipperId, history))
    }
  } catch (error) {
    yield put(airShipperInfoStatusUpdateFail(error))
  }
}

export function* AirShipperInfoStatusUpdateSaga() {
  yield takeEvery(AIR_SHIPPER_INFO_STATUS_UPDATE, AirShipperInfoStatusUpdate)
}

//sea shipper information status update
function* SeaShipperInfoStatusUpdate({ payload: { data, resetForm, dispatch, getSeaShipperInfo, shipperId, history } }) {
  try {
    yield put(seaShipperInfoStatusUpdateLoader(true))
    const response = yield call(seaShipperInfoStatusUpdate, data)
    yield put(seaShipperInfoStatusUpdateLoader(false))
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(seaShipperInfoStatusUpdateSuccess(response))
      resetForm
      dispatch(getSeaShipperInfo(shipperId, history))
    }
  } catch (error) {
    yield put(seaShipperInfoStatusUpdateFail(error))
  }
}

export function* SeaShipperInfoStatusUpdateSaga() {
  yield takeEvery(SEA_SHIPPER_INFO_STATUS_UPDATE, SeaShipperInfoStatusUpdate)
}